import React, {useCallback, useState} from 'react';
import { toast } from "react-toastify";
import {useTranslation} from "react-i18next";
import Swal from "sweetalert2";
import i18next from "i18next";

interface IState {
}

export interface IMessageContext {
    setPendingCount: (value: number) => void
    showToastDownloadMessage: () => void
    showDownloadMessage: () => void
}

export const MessagesContext = React.createContext<IMessageContext>({} as IMessageContext);

export function MessagesProvider(props: any) {
    const { t } = useTranslation();
    const [state, setState] = useState<IState>();

    const showToastDownloadMessage = useCallback((): void => {
        toast.info(t("settlementsDownloadFileNotification"));
    }, [state]);
    const showDownloadMessage = useCallback((): void => {
        Swal.fire({
            html: i18next.t("settlementsDownloadFileNotification"),
            confirmButtonColor: '#f60'
        });
    }, [state]);

    const value = React.useMemo(() => {
        return {
            showDownloadMessage,
            showToastDownloadMessage
        };
    }, 
    [
        state,
        showDownloadMessage,
        showToastDownloadMessage
    ]);

    return <MessagesContext.Provider value={value} {...props} />;
}

export function useMessages() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
  const context = React.useContext<IMessageContext>(MessagesContext);

  if (!context) {
    throw new Error('userMessages should be inside the provider MessagesContext');
  }

  return context;
}
